import our_journey_1 from "/public/images/icon/our-journey-1.png";
import our_journey_2 from "/public/images/icon/our-journey-2.png";
import our_journey_3 from "/public/images/icon/our-journey-3.png";
import our_journey_4 from "/public/images/icon/our-journey-4.png";

export const journey_carousel_data = [
  {
    id: 1,
    icon: our_journey_1,
    year: "2025 Q1",
    desc: "Survey lokasi, dan Renovasi Tempat usaha",
  },
  {
    id: 2,
    icon: our_journey_2,
    year: "2025 Q2",
    desc: "Permohonan Izin dan legalitas sesuai aturan yang berlaku.",
  },
  {
    id: 3,
    icon: our_journey_3,
    year: "2025 Q3",
    desc: "Tempat Usaha siap Renovasi, Izin lengkap.",
  },
  {
    id: 4,
    icon: our_journey_4,
    year: 2026,
    desc: "Mulai Beroperasi. Memberikan layanan penukaran valuta asing kepada masyarakat secara aman, nyaman, dan transparan.",
  },
    /*
  {
    id: 3,
    icon: our_journey_3,
    year: 2021,
    desc: "Nam blandit volutpat arcu. Nullam vitae elit arcu. Duis nec faucibus sapien. In sagittis, mauris vel laoreet elementum",
  },
  {
    id: 4,
    icon: our_journey_4,
    year: 2022,
    desc: "Nam blandit volutpat arcu. Nullam vitae elit arcu. Duis nec faucibus sapien. In sagittis, mauris vel laoreet elementum",
  },
  {
    id: 5,
    icon: our_journey_1,
    year: 2023,
    desc: "Nam blandit volutpat arcu. Nullam vitae elit arcu. Duis nec faucibus sapien. In sagittis, mauris vel laoreet elementum",
  },*/
];
